import md5 from 'md5'
import { document, window } from '@mtsbank/ui-kit'
import { authHelper } from '@entities/user'
import { pageType } from './constants'
import { Cd1Params } from './types'

export const emptyEvent = {
  event: null,
  eventCategory: null,
  eventAction: null,
  eventLabel: null,
  eventValue: null,
  userAuth: null,
  userId: null,
  grclientId: null,
  projectName: null,
  screenName: null,
  eventContent: null,
  eventContext: null,
  buttonLocation: null,
  filterName: null,
  pageType: null,
  actionGroup: null,
  productName: null,
  productId: null,
  intId: null,
  formId: null,
  bannerName: null,
  bannerId: null,
  regionId: null,
  region: null,
  ph: null,
  touchPoint: 'web',
  ref: null,
  _clear: true,
  CD1: null,
}

export type GtmEventPayload = {
  [K in keyof typeof emptyEvent]?: K extends 'CD1' ? Cd1Params | null : string | boolean | null
}

export type RedesignEventType = GtmEventPayload

export const getScreenName = () => document.location.pathname

const getPhoneHash = (): string | null => {
  const phone = authHelper.getPhone()

  if (!phone) {
    return null
  }

  return md5(String(phone))
}

export const getBaseEvent = () => ({
  ...emptyEvent,
  userAuth: authHelper.isAuthenticated() ? '1' : '0',
  userId: authHelper.fullUserInfo?.user_id ?? null,
  grclientId: authHelper.userData?.rbo_id ?? null,
  ph: getPhoneHash(),
  pageType,
  touchPoint: 'web',
  _clear: true,
})

export const sendGtmEvent = (event: GtmEventPayload) => {
  if (!window.dataLayer) {
    window.dataLayer = []
  }

  window.dataLayer.push({
    ...getBaseEvent(),
    ...event,
    screenName: getScreenName(),
  })
}
